module.exports = __webpack_public_path__ + "static/img/logo-天府再生协会.5512138e.png";